import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const content = {
    en: {
      breadcrumb: 'Home > About Us',
      title: 'About Peter & Partners Advocates LLP',
      subtitle: 'Building Trust Through Legal Excellence',
      description: `Founded on the principles of integrity, professionalism, and unwavering commitment to client success, Peter & Partners Advocates LLP has emerged as a trusted legal partner in Kenya's dynamic legal landscape.\n\nOur journey began with a simple yet powerful vision: to provide exceptional legal services that not only meet our clients' immediate needs but also contribute to their long-term success and growth.`,
      stats: [
        { number: '10+', label: 'Years of Experience' },
        { number: '500+', label: 'Cases Handled' },
        { number: '98%', label: 'Success Rate' },
        { number: '24/7', label: 'Client Support' }
      ]
    },
    sw: {
      breadcrumb: 'Nyumbani > Kuhusu Sisi',
      title: 'Kuhusu Peter & Partners Advocates LLP',
      subtitle: 'Kujenga Uaminifu Kupitia Ubora wa Kisheria',
      description: `Ilianzishwa kwa misingi ya uongozi, utaalamu, na kujitolea bila kikomo kwa mafanikio ya wateja, Peter & Partners Advocates LLP imejitokeza kama mshirika wa kisheria wa kuaminika katika mazingira ya kisheria ya Kenya.\n\nSafari yetu ilianza na maono rahisi lakini yenye nguvu: kutoa huduma za kisheria za kipekee ambazo si tu zinakidhi mahitaji ya haraka ya wateja wetu bali pia zinachangia mafanikio yao ya muda mrefu na ukuaji.`,
      stats: [
        { number: '10+', label: 'Miaka ya Uzoefu' },
        { number: '500+', label: 'Kesi Zilizoshughulikiwa' },
        { number: '98%', label: 'Kiwango cha Mafanikio' },
        { number: '24/7', label: 'Msaada wa Wateja' }
      ]
    }
  };

  const currentContent = content[currentLanguage];

  return (
    <section className="relative bg-gradient-to-br from-background via-surface/10 to-primary/5 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="mb-8">
          <div className="flex items-center space-x-2 text-sm font-caption">
            <Icon name="Home" size={16} className="text-text-secondary" />
            <span className="text-text-secondary">{currentContent.breadcrumb}</span>
          </div>
        </nav>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-5xl font-heading font-bold text-text-primary leading-tight">
                {currentContent.title}
              </h1>
              <h2 className="text-xl lg:text-2xl font-heading font-semibold text-primary">
                {currentContent.subtitle}
              </h2>
              <div className="prose prose-lg max-w-none">
                {currentContent.description.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="text-text-secondary leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {currentContent.stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl lg:text-3xl font-heading font-bold text-primary">
                    {stat.number}
                  </div>
                  <div className="text-sm font-caption text-text-secondary mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-lg">
              <Image
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Peter & Partners Law Office"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-6 max-w-xs">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
                  <Icon name="Scale" size={24} color="white" />
                </div>
                <div>
                  <div className="font-heading font-semibold text-text-primary">
                    {currentLanguage === 'en' ? 'Trusted Legal Partner' : 'Mshirika wa Kisheria wa Kuaminika'}
                  </div>
                  <div className="text-sm font-caption text-text-secondary">
                    {currentLanguage === 'en' ? 'Since 2014' : 'Tangu 2014'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;